var AddedScoresModifier = /** @class */ (function () {
    function AddedScoresModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    AddedScoresModifier.prototype.modify = function (content) {
        if (content.scores === undefined || content.scores.add === undefined) {
            return;
        }
        var scores = content.scores.add;
        for (var i = 0; i < scores.length; i++) {
            var score = scores[i];
            var scoreKey = this._modelKeyRepository.addScore(score.e, score.id);
            scores[i] = Object.assign({
                score1: score.s1,
                score2: score.s2,
                team: score.tm,
                type: score.t,
                isActive: score.ia
            }, scoreKey);
        }
    };
    return AddedScoresModifier;
}());
export default AddedScoresModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/AddedScoresModifier.js